import { render } from "./SubmitPurchase.vue?vue&type=template&id=07028a04&scoped=true&ts=true"
import script from "./SubmitPurchase.vue?vue&type=script&lang=ts"
export * from "./SubmitPurchase.vue?vue&type=script&lang=ts"

import "./SubmitPurchase.vue?vue&type=style&index=0&id=07028a04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07028a04"]])

export default __exports__